// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef872f42","453":"6f8e28c0","667":"85c6e1e0","977":"fe71dcfd"}[chunkId] + ".chunk.js";
};